import styled from "styled-components";

export const VideoBlockSection = styled("section")`
  max-width: 1200px;
  margin-right: auto;
  margin-left: auto;
  justify-content: center;
  padding-top: 80px;
  padding-bottom: 80px;

`;
export const Video = styled("iframe")`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid black;
`;
export const VideoContainer = styled("div")`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  border: 1px solid black;

  border-radius: 9px;
  box-shadow: 0 16px 30px rgb(23 31 114 / 20%);
`;


export const Content = styled("p")`
  padding: 0.75rem 0 0.75rem;
`;

export const ContentWrapper = styled("div")`
  max-width: 570px;

  @media only screen and (max-width: 768px) {
    max-width: 100%;
  }
`;
